import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  const quickLinks = [
    { name: 'K-12 Mathematics', href: '#learning-system', type: 'scroll' },
    { name: 'Test Preparation', href: '#learning-system', type: 'scroll' },
    { name: 'Free Resources', href: '#free-section', type: 'scroll' },
    { name: 'Mathematics Books', href: '#books-section', type: 'scroll' }
  ];

  const membership = [
    { name: 'Single Grade Level', href: '#membership-tiers', type: 'scroll' },
    { name: 'K-5 Bundle', href: '#membership-tiers', type: 'scroll' },
    { name: '6-12 Bundle', href: '#membership-tiers', type: 'scroll' },
    { name: 'Complete Access', href: '#membership-tiers', type: 'scroll' }
  ];

  const support = [
    { name: 'Personal Tutoring', href: '#tutoring-form', type: 'scroll' },
    { name: 'Success Stories', href: '/success-stories', type: 'route' },
    { name: 'Contact Us', href: '#contact-form', type: 'scroll' },
    { name: 'FAQ', href: '#', type: 'scroll' }
  ];

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string, type: string) => {
    e.preventDefault();
    if (type === 'route') {
      navigate(href);
    } else {
      const element = document.querySelector(href);
      element?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-white/50">
                <img 
                  src="https://public.readdy.ai/ai/img_res/7ed708d0-0e46-4404-b490-9c89f3f516ab.png" 
                  alt="Augustine Anyimadu-Ahenkae"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div>
                <h3 className="text-xl font-bold">Augustine Anyimadu-Ahenkae</h3>
                <p className="text-sm text-gray-300">Master Mathematics Educator</p>
              </div>
            </div>
            <p className="text-base text-gray-300 leading-relaxed mb-6">
              30+ years of teaching excellence in NYC Public Schools. Chancellor's Honor Award recipient dedicated to making mathematics accessible and enjoyable for every student.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-12 h-12 flex items-center justify-center rounded-full bg-white/10 hover:bg-emerald-600 transition-all duration-300 cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-12 h-12 flex items-center justify-center rounded-full bg-white/10 hover:bg-emerald-600 transition-all duration-300 cursor-pointer">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a href="#" className="w-12 h-12 flex items-center justify-center rounded-full bg-white/10 hover:bg-emerald-600 transition-all duration-300 cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="w-12 h-12 flex items-center justify-center rounded-full bg-white/10 hover:bg-emerald-600 transition-all duration-300 cursor-pointer">
                <i className="ri-youtube-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.href}
                    onClick={(e) => handleLinkClick(e, link.href, link.type)}
                    className="text-base text-gray-300 hover:text-emerald-400 transition-colors duration-300 cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Membership */}
          <div>
            <h4 className="text-lg font-bold mb-6">Membership</h4>
            <ul className="space-y-3">
              {membership.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.href}
                    onClick={(e) => handleLinkClick(e, link.href, link.type)}
                    className="text-base text-gray-300 hover:text-emerald-400 transition-colors duration-300 cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-lg font-bold mb-6">Support</h4>
            <ul className="space-y-3">
              {support.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.href}
                    onClick={(e) => handleLinkClick(e, link.href, link.type)}
                    className="text-base text-gray-300 hover:text-emerald-400 transition-colors duration-300 cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Contact Info */}
        <div className="border-t border-white/10 pt-8 mb-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-emerald-600">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <div>
                <p className="text-sm text-gray-400">Email</p>
                <p className="text-base font-semibold">contact@mathmastery.com</p>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-emerald-600">
                <i className="ri-phone-line text-xl"></i>
              </div>
              <div>
                <p className="text-sm text-gray-400">Phone</p>
                <p className="text-base font-semibold">(555) 123-4567</p>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-emerald-600">
                <i className="ri-map-pin-line text-xl"></i>
              </div>
              <div>
                <p className="text-sm text-gray-400">Location</p>
                <p className="text-base font-semibold">New York, NY</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-400">
            © 2024 Augustine Anyimadu-Ahenkae. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-sm text-gray-400 hover:text-emerald-400 transition-colors duration-300 cursor-pointer">
              Privacy Policy
            </a>
            <a href="#" className="text-sm text-gray-400 hover:text-emerald-400 transition-colors duration-300 cursor-pointer">
              Terms of Service
            </a>
            <a href="#" className="text-sm text-gray-400 hover:text-emerald-400 transition-colors duration-300 cursor-pointer">
              Refund Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
